import { useState, FC } from "react";
import styles from "./users-list-view.module.css";
import { useTranslation } from "@coworker/locales";
import { SimpleToast } from "../../../../simple/SimpleToast/SimpleToast";
import { FixaListView } from "../../../../wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "../../../../wrappers/FixaListView/FixaListViewItem";
import {
  useAvatarImage,
  useGraphDisplayName,
} from "@coworker/app/src/hooks/API/avatar.service";

interface SuperUserListItem {
  uid?: string;
  email: string;
  fullName: string;
}

interface UserListViewItemProps {
  user: SuperUserListItem;
  index: number;
  onCopy: (email: string) => void;
}

const UserListViewItem: FC<UserListViewItemProps> = ({
  user,
  index,
  onCopy,
}) => {
  const avatarUrl = useAvatarImage(user.email);
  const graphDisplayName = useGraphDisplayName(user.fullName ? "" : user.email);
  const displayName = user.fullName || graphDisplayName || user.email;
  return (
    <FixaListViewItem
      className={styles["users-list-view-item"] || ""}
      name={user.uid ?? `user_${index}`}
      control={"navigational"}
      controlIcon={"copy"}
      onClick={() => onCopy(user.email)}
      title={displayName}
      description={displayName !== user.email ? user.email : undefined}
      image={avatarUrl}
    />
  );
};

interface UsersListViewProps {
  users: SuperUserListItem[] | undefined;
  id: string;
}
export const UsersListView: FC<UsersListViewProps> = ({ users, id }) => {
  const [toastVisible, setToastVisible] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState("");
  const { t } = useTranslation();
  const copyUserEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setToastVisible(true);
  };
  return (
    <div>
      <SimpleToast
        text={`${t("copiedString")} ${copiedEmail}!`}
        isOpen={toastVisible}
        onCloseRequest={() => {
          setToastVisible(false);
        }}
        ariaLabelCloseBtn={t("dismissNotificationString")}
        ariaLabel={t("copyUserEmailString")}
      />
      <FixaListView
        key={id}
        id={id}
        className={styles["users-list-view"] ?? ""}
      >
        {users?.map((user: SuperUserListItem, index: number) => (
          <UserListViewItem
            key={user?.uid ?? `user_${index}`}
            user={user}
            index={index}
            onCopy={copyUserEmail}
          />
        ))}
      </FixaListView>
    </div>
  );
};
